import { useCallback, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import AdminLogin from "@/components/admin/AdminLogin";
import LeadsPanel from "@/components/admin/LeadsPanel";
import ContentEditor from "@/components/admin/ContentEditor";
import HeroImagesPanel from "@/components/admin/HeroImagesPanel";

const KEY = "as_admin_token";
const TABS = [
    { id: "leads", label: "Contactos" },
    { id: "contenido", label: "Contenido" },
    { id: "imagenes", label: "Imágenes del inicio" },
];

export default function Admin() {
    const [token, setToken] = useState(() => sessionStorage.getItem(KEY));
    const [tab, setTab] = useState("leads");

    const login = (t) => {
        sessionStorage.setItem(KEY, t);
        setToken(t);
    };
    const logout = useCallback(() => {
        sessionStorage.removeItem(KEY);
        setToken(null);
    }, []);

    if (!token) return <AdminLogin onLogin={login} />;

    return (
        <div className="min-h-screen bg-navy text-[#F8F9FA]" data-testid="admin-shell">
            <nav className="flex gap-2 border-b border-white/10 px-6 pt-6 md:px-12" data-testid="admin-tabs">
                {TABS.map((t) => (
                    <button
                        key={t.id}
                        onClick={() => setTab(t.id)}
                        className={`border-b-2 px-4 pb-3 text-[11px] uppercase tracking-[0.22em] transition-colors ${
                            tab === t.id ? "border-gold text-gold" : "border-transparent text-[#9CA3AF] hover:text-[#F8F9FA]"
                        }`}
                        data-testid={`admin-tab-${t.id}`}
                    >
                        {t.label}
                    </button>
                ))}
            </nav>
            {tab === "leads" && <LeadsPanel token={token} onLogout={logout} />}
            {tab === "contenido" && (
                <div className="px-6 pb-16 md:px-12">
                    <ContentEditor token={token} />
                </div>
            )}
            {tab === "imagenes" && (
                <div className="px-6 pb-16 md:px-12">
                    <HeroImagesPanel token={token} />
                </div>
            )}
            <Toaster position="top-center" richColors closeButton />
        </div>
    );
}
